import React from "react";

interface InputTextProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string,
  displaySize?: "sm" | "md" | "lg";
}

const InputText = React.forwardRef<HTMLInputElement, InputTextProps>(
  ({ type = "text", displaySize = "md", className, ...attributes }, ref) => {
    return (
      <input
        ref={ref}
        className={`
          form-field
          block w-full px-3 py-2.5 border border-gray-900 bg-transparent rounded focus:outline-none focus:ring-1 focus:ring-secondary focus:border-secondary placeholder:text-gray-200 ${className || ""}`}
        type={type}
        {...attributes}
      />
    );
  }
);

InputText.displayName = "InputText";

export default InputText;
